
import Vue from 'vue'
import Router from 'vue-router'
import History from '@/pages/history'
import Doc from '@/pages/doc1'
import Translation from '@/pages/translation'
import Favorite from '@/pages/favorites'
import Fanyi from '@/pages/fanyiup'
import API from '@/pages/api'
import Mine from '@/pages/mine'
import Personal from '@/pages/personal'
import Read from '@/pages/read'
import Vip from '@/pages/vip'
import PdfView from '@/pages/pdfview_pay'
Vue.use(Router)

const routes = [
  { path: '/mine/',
    component: Mine,
    children: [
      {
        path: '',
        redirect: '/mine/doc',
        name: 'doc',
      },
      {
        path: 'history',
        name: 'History',
        component: History,
      },
      {
        path: 'doc',
        name: 'Doc',
        component: Doc,
      },
      {
        path: 'favorite',
        name: 'Favorite',
        component: Favorite,
      },
      {
        path: 'translation',
        name: 'Translation',
        component: Translation,
      },
      {
        path: 'personal',
        name: 'Personal',
        component: Personal,
      },
      {
        path: 'vip',
        name: 'Vip',
        component: Vip,
      },
    ],
  },
  { path: '/fanyi', component: Fanyi, name: 'Fanyi' },
  { path: '/api', component: API, name: 'Api' },
  { path: '/read/:id', component: Read },
  { path: '/pdf_view/:id', component: PdfView },
  // { path: '', redirect: '/' ,name:'Fanyi'},
  {
    path: '*',
    redirect: '/mine/',
  },
]

export default new Router({
  routes,
})



// WEBPACK FOOTER //
// ./src/router/index.js